import React from "react";

const FinancialExpressLogo = ({ src, alt, ...rest }) => <img src="/images/fe-logo.png" alt="fe-logo" {...rest} />

export default FinancialExpressLogo;